import React, { useEffect, useState } from 'react';
import { Divider } from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { CommonPagination, ScreenContainer } from '../../../CommonComponents';
import {
  getAllSites,
  getFilters,
  getFilterSitesByAuditorAction,
  getSitesDataByEstimateId,
  updatePrimaryQuery,
  updateSearchQuery,
  updateSitesAuditorVisibility,
} from '../../../redux/actions/sites';
import SitesFilter from '../../../CommonComponents/SitesFilter/SitesFilter';
import FallbackCard from '../../../CommonComponents/FallbackCard';
import ClientPrimaryFilters from '../../../CommonComponents/ClientPrimaryFilters';
import { atrFetchReport } from '../../../redux/actions/common';
import SiteRapportAuditorTable from './SiteRapportAuditorTable';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SiteRapportAuditor = ({
  getAllSitesAction,
  totalSitePages,
  updateQuery,
  primaryQuery,
  searchQuery,
  fetchSites,
  getFilter,
  updateSitesAuditorVisibilityFn,
  filterSitesByAuditorAction,
  fetchReport,
}) => {
  const query = useQuery();
  const { pathname } = useLocation();
  const history = useHistory();
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);

  useEffect(() => {
    const pno = query.get('page');
    if (showSites && pno) getAllSitesAction(page, searchQuery, primaryQuery);
  }, [
    query,
    getAllSitesAction,
    getFilter,
    searchQuery,
    primaryQuery,
    showSites,
    page,
  ]);

  const fetchAllSite = (val) => {
    if (query.has('estimateId')) {
      query.set('estimateId', val);
    } else {
      query.append('estimateId', val);
    }
    query.delete('page');
    history.push('/site-rapport-auditor');
    updateQuery(query.toString());
    fetchSites(val);
    enableSites(true);
  };
  const fetchReports = (val) => {
    fetchReport({ campaignNo: val });
  };

  const updateSitesVisibility = async (siteIds) => {
    await updateSitesAuditorVisibilityFn(
      siteIds,
      page,
      primaryQuery,
      searchQuery,
    );
  };

  const handleAuditorActionFilter = async (status) => {
    filterSitesByAuditorAction(page, primaryQuery, searchQuery, status);
  };

  useEffect(() => {
    enableSites(false);
  }, [pathname]);

  return (
    <ScreenContainer
      title={
        pathname === '/site-rapport-auditor'
          ? 'Reported Sites'
          : 'FOC Report'
      }
    >
      {pathname === '/site-rapport-auditor' ? (
        <ClientPrimaryFilters
          visibleProduct
          visibleEstimate
          fetchFunction={fetchAllSite}
          location="siteRapportAuditor"
          showFetchButton
        />
      ) : (
        <ClientPrimaryFilters
          visibleProduct
          visibleEstimate
          fetchFunction={fetchReports}
          location="atrReport"
          showFetchButton={false}
        />
      )}
      <br />
      {showSites ? (
        <>
          <SitesFilter currentLocation="site-rapport-auditor" />
          <div className="row">
            <Divider />
            <div className="col-12">
              <br />
              <SiteRapportAuditorTable
                updateSitesAuditorVisibility={updateSitesVisibility}
                handleAuditorActionFilter={handleAuditorActionFilter}
              />
              {totalSitePages > 1 ? (
                <CommonPagination
                  baseUrl="site-rapport-auditor"
                  totalPages={totalSitePages}
                />
              ) : null}
              <br />
            </div>
          </div>
        </>
      ) : (
        <FallbackCard text="Fetch the sites to start" />
      )}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  filterSitesByAuditorAction: getFilterSitesByAuditorAction,
  updateQuery: updatePrimaryQuery,
  updateSearchQueryFn: updateSearchQuery,
  fetchSites: getSitesDataByEstimateId,
  getFilter: getFilters,
  updateSitesAuditorVisibilityFn: updateSitesAuditorVisibility,
  fetchReport: atrFetchReport,
};

export default connect(mapState, mapActions)(SiteRapportAuditor);
